import { NgcCookieConsentConfig } from 'ngx-cookieconsent';

export const cookieConfig: NgcCookieConsentConfig = {
    cookie: {
        domain: 'zehentmoar.at',
    },
    position: 'bottom-right',
    theme: 'edgeless',
    palette: {
        popup: {
            background: '#F2F2F2',
            text: 'hsl(345, 6%, 10%)',
            link: 'hsl(345, 6%, 10%)',
        },
        button: {
            background: 'hsl(32, 51%, 36%)',
            text: '#F2F2F2',
            border: 'transparent',
        },
    },
    type: 'info',
    content: {
        message:
            'Diese Website verwendet Cookies, um sicherzustellen, dass Sie die bestmögliche Erfahrung auf unserer Website erzielen.',
        dismiss: 'Verstanden',
        deny: 'Ablehnen',
        link: 'Mehr erfahren',
        href: '/hof/datenschutz',
        policy: 'Cookie-Richtlinie',
    },
};
